import _classNames from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icons/Icon/Icon';
import Tooltip from '../tooltip/tooltip';

function Pill({ changeAmount, period, text, tooltip }) {
  let changeString = null;
  let separator = null;
  if (changeAmount > 0) {
    changeString = `+${changeAmount}%`;
    separator = (
      <Icon name="Arrow--long--northeast" size="minor" svgProps={{ style: { fill: '#ffffff' } }} />
    );
  } else if (changeAmount < 0) {
    changeString = `${changeAmount}%`;
    separator = (
      <Icon name="Arrow--long--southeast" size="minor" svgProps={{ style: { fill: '#ffffff' } }} />
    );
  } else if (changeAmount === 0) {
    changeString = 'No change';
    separator = '/';
  }

  const hasTooltip = tooltip && tooltip.content;

  const pill = (
    <div
      className={_classNames('Pill', {
        'Pill--hasTooltip': hasTooltip,
      })}
    >
      {text ? (
        <div className="Pill__content">{text}</div>
      ) : (
        <>
          <div className="Pill__changeAmount">{changeString}</div>
          <div
            className={_classNames('Pill__separator', {
              'Pill__separator--string': separator === '/',
            })}
          >
            {separator}
          </div>
          <div className="Pill__period">{period}</div>
        </>
      )}
    </div>
  );

  return hasTooltip ? (
    <div className="Pill__wrapper">
      <Tooltip block content={tooltip.content} title={tooltip?.title} light>
        {pill}
      </Tooltip>
    </div>
  ) : (
    pill
  );
}

Pill.propTypes = {
  /**
   * This number should reflect the percentage the data set has changed in the `period`.
   * Positive numbers will display as an upward trend, negative numbers will display as a downward
   * trend, and 0 will be reflected as "No change". Decimal points will be reflected in whatever
   * manner they are sent to the component, for example, set this amount to `3.7` to reflect a
   * positive change in the amount of 3.7%.
   */
  changeAmount: PropTypes.number,
  /**
   * The current period where data is being compared (i.e. "Last week")
   */
  period: PropTypes.string,
  /**
   * Any text or node to show within the pill; this will replace any `changeAmount` and `period` data
   */
  text: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  /**
   * If provided, the component will be wrapped in the Tooltip component. Object must contain a `content` key for the main content of the Tooltip, and may also include a `title` key.
   */
  tooltip: PropTypes.shape({
    content: PropTypes.string.isRequired,
    title: PropTypes.string,
  }),
};

Pill.defaultProps = {
  changeAmount: undefined,
  period: undefined,
  text: undefined,
  tooltip: undefined,
};

export default Pill;
